export const actionTypes = {
  UPDATE_ROW_SUCCESS: "UPDATE_ROW_SUCCESS",

  GET_ROLE_LIST_PENDING: "GET_ROLE_LIST_PENDING",
  GET_ROLE_LIST_SUCCESS: "GET_ROLE_LIST_SUCCESS",
  GET_ROLE_LIST_ERROR: "GET_ROLE_LIST_ERROR",

  GET_CATEGORY_LIST_PENDING: "GET_CATEGORY_LIST_PENDING",
  GET_CATEGORY_LIST_SUCCESS: "GET_CATEGORY_LIST_SUCCESS",
  GET_CATEGORY_LIST_ERROR: "GET_CATEGORY_LIST_ERROR",

  GET_TAGS_LIST_PENDING: "GET_TAGS_LIST_PENDING",
  GET_TAGS_LIST_SUCCESS: "GET_TAGS_LIST_SUCCESS",
  GET_TAGS_LIST_ERROR: "GET_TAGS_LIST_ERROR",

  GET_STATUS_LIST_PENDING: "GET_STATUS_LIST_PENDING",
  GET_STATUS_LIST_SUCCESS: "GET_STATUS_LIST_SUCCESS",
  GET_STATUS_LIST_ERROR: "GET_STATUS_LIST_ERROR",

  GET_LANGUAGES_LIST_PENDING: "GET_LANGUAGES_LIST_PENDING",
  GET_LANGUAGES_LIST_SUCCESS: "GET_LANGUAGES_LIST_SUCCESS",
  GET_LANGUAGES_LIST_ERROR: "GET_LANGUAGES_LIST_ERROR",

  GET_YOUTUBE_SOURCE_LIST_PENDING: "GET_YOUTUBE_SOURCE_LIST_PENDING",
  GET_YOUTUBE_SOURCE_LIST_SUCCESS: "GET_YOUTUBE_SOURCE_LIST_SUCCESS",
  GET_YOUTUBE_SOURCE_LIST_ERROR: "GET_YOUTUBE_SOURCE_LIST_ERROR",

  GET_BANNER_SCREEN_LIST_PENDING: "GET_BANNER_SCREEN_LIST_PENDING",
  GET_BANNER_SCREEN_LIST_SUCCESS: "GET_BANNER_SCREEN_LIST_SUCCESS",
  GET_BANNER_SCREEN_LIST_ERROR: "GET_BANNER_SCREEN_LIST_ERROR",

  GET_DEVICE_LIST_PENDING: "GET_DEVICE_LIST_PENDING",
  GET_DEVICE_LIST_SUCCESS: "GET_DEVICE_LIST_SUCCESS",
  GET_DEVICE_LIST_ERROR: "GET_DEVICE_LIST_ERROR",

  GET_SUBSCRIPTION_LIST_PENDING: "GET_SUBSCRIPTION_LIST_PENDING",
  GET_SUBSCRIPTION_LIST_SUCCESS: "GET_SUBSCRIPTION_LIST_SUCCESS",
  GET_SUBSCRIPTION_LIST_ERROR: "GET_SUBSCRIPTION_LIST_ERROR",

  ADD_TAG_PENDING: "ADD_TAG_PENDING",
  ADD_TAG_SUCCESS: "ADD_TAG_SUCCESS",
  ADD_TAG_ERROR: "ADD_TAG_ERROR",

  GET_NOTIFICATION_TYPE_LIST_PENDING: "GET_NOTIFICATION_TYPE_LIST_PENDING",
  GET_NOTIFICATION_TYPE_LIST_SUCCESS: "GET_NOTIFICATION_TYPE_LIST_SUCCESS",
  GET_NOTIFICATION_TYPE_LIST_ERROR: "GET_NOTIFICATION_TYPE_LIST_ERROR",

  GET_PLATFORM_PENDING: "GET_PLATFORM_PENDING",
  GET_PLATFORM_SUCCESS: "GET_PLATFORM_SUCCESS",
  GET_PLATFORM_ERROR: "GET_PLATFORM_ERROR",

  GET_TOPIC_LIST_PENDING: "GET_TOPIC_LIST_PENDING",
  GET_TOPIC_LIST_SUCCESS: "GET_TOPIC_LIST_SUCCESS",
  GET_TOPIC_LIST_ERROR: "GET_TOPIC_LIST_ERROR",
};

const initialState = {
  addTagPending: false,
  addTagSuccess: false,
  addTagError: null,

  roleList: [],
  categories: [],
  tags: [],
  status: [],
  languages: [],
  youTubeSourceList: [],
  bannerScreenList: [],
  deviceList: [],
  subscriptionList: [],
  notificationTypeList: [],
  platforms: [],
  topicList: [],

  showRowsPerPage: { label: "10", value: 10 },
};

export default function master(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.GET_ROLE_LIST_PENDING:
    case actionTypes.GET_ROLE_LIST_SUCCESS:
    case actionTypes.GET_ROLE_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_CATEGORY_LIST_PENDING:
    case actionTypes.GET_CATEGORY_LIST_SUCCESS:
    case actionTypes.GET_CATEGORY_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_TAGS_LIST_PENDING:
    case actionTypes.GET_TAGS_LIST_SUCCESS:
    case actionTypes.GET_TAGS_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_STATUS_LIST_PENDING:
    case actionTypes.GET_STATUS_LIST_SUCCESS:
    case actionTypes.GET_STATUS_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_LANGUAGES_LIST_PENDING:
    case actionTypes.GET_LANGUAGES_LIST_SUCCESS:
    case actionTypes.GET_LANGUAGES_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_YOUTUBE_SOURCE_LIST_PENDING:
    case actionTypes.GET_YOUTUBE_SOURCE_LIST_SUCCESS:
    case actionTypes.GET_YOUTUBE_SOURCE_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.ADD_TAG_PENDING:
    case actionTypes.ADD_TAG_SUCCESS:
    case actionTypes.ADD_TAG_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_BANNER_SCREEN_LIST_PENDING:
    case actionTypes.GET_BANNER_SCREEN_LIST_SUCCESS:
    case actionTypes.GET_BANNER_SCREEN_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_DEVICE_LIST_PENDING:
    case actionTypes.GET_DEVICE_LIST_SUCCESS:
    case actionTypes.GET_DEVICE_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_SUBSCRIPTION_LIST_PENDING:
    case actionTypes.GET_SUBSCRIPTION_LIST_SUCCESS:
    case actionTypes.GET_SUBSCRIPTION_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_NOTIFICATION_TYPE_LIST_PENDING:
    case actionTypes.GET_NOTIFICATION_TYPE_LIST_SUCCESS:
    case actionTypes.GET_NOTIFICATION_TYPE_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_PLATFORM_PENDING:
    case actionTypes.GET_PLATFORM_SUCCESS:
    case actionTypes.GET_PLATFORM_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_TOPIC_LIST_PENDING:
    case actionTypes.GET_TOPIC_LIST_SUCCESS:
    case actionTypes.GET_TOPIC_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_ROW_SUCCESS:
      return Object.assign({}, state, payload);

    default:
      return state;
  }
}
